import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const TRANSACTIONS_API_PATH = '/api/transactions';

const getTransactions = async (filters = { period: 'today' }) => {
  const response = await axios.get(`${API_BASE_URL}${TRANSACTIONS_API_PATH}`, { params: filters });
  return response.data;
};

const getTransactionDetail = async (id, type) => {
  const response = await axios.get(`${API_BASE_URL}${TRANSACTIONS_API_PATH}/${id}`, {
    params: type ? { type } : undefined,
  });
  return response.data;
};

const transactionService = {
  getTransactions,
  getTransactionDetail,
};

export default transactionService;
